import * as React from "react";
const SvgViewOperations = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "#909CAF", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.7, d: "M4 12a8 8 0 1 0 1.755-5M12 8v4l2.5 2.5M5.754 4.004v3h3" }));
export default SvgViewOperations;
